import React from "react";
import "./App.scss";

import Footer from "./components/general/footer/Footer";
import Header from "./components/general/header/Header";
import BodyRouter from "./router/BodyRouter";
import FooterRouter from "./router/FooterRouter";
import SideBox from "./components/general/background/SideBox";

function App() {
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />
      <div
        className="app__container flex-grow-1 mb-3"
        //new add test
        style={{ position: "relative" }}
        //new add test
      >
        <BodyRouter />
      </div>
      <SideBox />
      <FooterRouter />
      <Footer />
    </div>
  );
}

export default App;
